export default {
  AnswerBrief: 'Answer Brief',
  AnswerFull: 'Answer Full',
  ClientType: 'Client Type',
  Question: 'Question',
  Category: 'Category',
  question_: 'Question',
  domain: 'metaDomain',
  subDomain: 'metaSubDomain',
  header: 'Header',
  footer: 'Footer',
  sidebar: 'Sidebar',
  topHeader: 'Top-Header',
  type: 'Type',
  selectFromTemplate: 'Select from template',
  faqCategoryId: 'Faq category ID',
  postCategoryId: 'Post category ID',
  primarycategory: 'Primary category',
  categories: 'Categories',
  response: 'Response',
  responder: 'Responder',
  commentResponseSuccessfullyRegisterd:
    'Comment response successfully registered',
  approve: 'Approve',
  reject: 'Reject',
  commentResponse: 'Comment response',
  tags: 'Tags',
  excerpt: 'Excerpt',
  tutorial: 'tutorial'
}
